import React from 'react';
import upperFirst from 'lodash.upperfirst';
import T from 'prop-types';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

import * as Colors from '../../attrs/colors';
import * as fmt from '../../utils/formatters';

const confirm = (onOk, content) => {
  Modal.confirm({
    title: 'Confirm Subscription Cancellation',
    content,
    okText: 'Cancel my subscription',
    okButtonProps: { type: 'danger' },
    cancelText: 'Cancel',
    maskClosable: true,
    onOk: (close) => {
      onOk();
      close();
    },
    icon: <ExclamationCircleOutlined fill={Colors.RED} />,
  });
};

const CancelSubscriptionButton = ({ cancelActiveSub, isCanceled, plan, subscriptionPeriodEnd }) => {
  const planName = upperFirst(plan);
  const date = fmt.dateHumanize(subscriptionPeriodEnd);
  const content = `You will have access to the ${planName} plan until ${date}. After this date, your account will revert to the Standard plan.`;

  return (
    <Button disabled={isCanceled} onClick={() => confirm(cancelActiveSub, content)} type="danger">
      Cancel Subscription
    </Button>
  );
};

CancelSubscriptionButton.propTypes = {
  isCanceled: T.bool.isRequired,
  cancelActiveSub: T.func.isRequired,
  subscriptionPeriodEnd: T.number.isRequired,
  plan: T.string.isRequired,
};

export default CancelSubscriptionButton;
